/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { adminInstance } from '../../config/axios';

import { Loader } from 'react-feather';
import TransactionHistoryTable from './listDataTable';

const Transactions = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getAllHistory = async () => {
    setLoading(true);
    try {
      const response = await adminInstance().get(
        'api/admin/getPaymentTransaction'
      );
      console.log('I am here==========>>', response);
      if (response?.data?.code === 200) {
        setLoading(false);
        setData(response?.data?.transactionHistory);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getAllHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* {loading && <Loader />} */}
      <Fragment>
        <Breadcrumb title='Transactions' parent='Transaction' />
        <Container fluid={true}>
          <Row>
            <Col sm='12'>
              <Card>
                <CardHeader>
                  <h5>Transaction History</h5>
                </CardHeader>
                <CardBody>
                  <div id='batchDelete' className='transactions'>
                    {!loading ? (
                      <TransactionHistoryTable
                        multiSelectOption={true}
                        myData={data}
                        pageSize={10}
                        pagination={true}
                        class='-striped -highlight'
                      />
                    ) : (
                      <Loader />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </>
  );
};

export default Transactions;
